import firebase from 'firebase/compat/app';
import 'firebase/compat/storage';

const firebaseConfig = {
    apiKey: "AIzaSyAFlRJyQ9ULxdi6gVfdK13xpgD3u0LGZdk",
    authDomain: "bloom-images-storage.firebaseapp.com",
    projectId: "bloom-images-storage",
    storageBucket: "bloom-images-storage.appspot.com",
    messagingSenderId: "772345713473",
    appId: "1:772345713473:web:bd47e450a7aca4f1e387c0",
    measurementId: "G-MTD5LGF61C"
  };

firebase.initializeApp(firebaseConfig)

const storage = firebase.storage()

export { storage, firebase as default }